import React from 'react';
import { Link } from 'react-router-dom';
import Image from "@scentregroup/ui/components/image";
import { displayStringForPriceRange } from '../../helpers/product-price';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const cloudinaryPrefix = "https://res.cloudinary.com/scentre-group-au/image/fetch/";

const WestfieldProductCard = _ref => {
  let {
    westfieldProduct,
    index,
    mkpCartCount,
    onClick
  } = _ref;
  let url = westfieldProduct.href;

  if (westfieldProduct.objectID === 'physical-gift-card') {
    url += "?wd=".concat(mkpCartCount > 0 ? 1 : 0);
  }

  return /*#__PURE__*/_jsx("div", {
    className: style.westfieldProductCard,
    "data-test-id": "westfield-product-card",
    "data-insights-object-id": westfieldProduct.objectID,
    "data-insights-position": index,
    "data-id": "westfield-product-card_index_WestfieldProductCard_div",
    children: /*#__PURE__*/_jsxs(Link, {
      className: style.westfieldProductLinkWrapper,
      to: url,
      onClick: () => onClick ? onClick() : null,
      "data-id": "westfield-product-card_index_WestfieldProductCard_div_Link",
      children: [/*#__PURE__*/_jsx(Image, {
        className: style.westfieldProductImage,
        imageUrl: "".concat(cloudinaryPrefix).concat(westfieldProduct.image),
        alt: westfieldProduct.name,
        ratio: "poster",
        bgSize: "contain",
        type: "mobile",
        "data-id": "westfield-product-card_index_WestfieldProductCard_Link_Image"
      }), /*#__PURE__*/_jsx("div", {
        className: style.westfieldProductName,
        "data-id": "westfield-product-card_index_WestfieldProductCard_Link_div",
        children: westfieldProduct.name
      }), /*#__PURE__*/_jsx("div", {
        className: style.price,
        "data-id": "westfield-product-card_index_WestfieldProductCard_Link_div_4",
        children: displayStringForPriceRange({
          min: westfieldProduct.minPrice,
          max: westfieldProduct.maxPrice
        })
      }), /*#__PURE__*/_jsx("div", {
        className: style.westfieldProductDescription,
        "data-id": "westfield-product-card_index_WestfieldProductCard_Link_div_5",
        children: westfieldProduct.description
      })]
    })
  });
};

export default WestfieldProductCard;